var _style, _circle, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1Of3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A8DCEE;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#144069;}\r\n\t.st3{fill:none;stroke:#4ABCE6;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6_2_",
    className: "st0",
    cx: 45.1,
    cy: 45.2,
    r: 30.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.3,65.3c3.4-5.9,5.3-12.8,5.3-20.1c0-22.4-18.1-40.5-40.5-40.5c-0.1,0-0.1,0-0.2,0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    transform: "translate(-94.288 -110.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.4,161.9h-3.6V152l0-1.6l0.1-1.8c-0.6,0.6-1,1-1.3,1.2l-2,1.6l-1.7-2.2l5.5-4.4h3V161.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.6,148.6c0,1.1-0.3,2-1,2.7s-1.6,1.3-2.7,1.5v0.1c1.4,0.2,2.4,0.6,3.1,1.3s1.1,1.6,1.1,2.7 c0,1.6-0.6,2.9-1.8,3.8s-2.9,1.4-5.1,1.4c-1.9,0-3.5-0.3-4.9-0.9v-3.1c0.7,0.3,1.4,0.6,2.2,0.8s1.6,0.3,2.4,0.3 c1.2,0,2.1-0.2,2.6-0.6s0.9-1.1,0.9-2c0-0.8-0.3-1.4-1-1.7s-1.7-0.5-3.1-0.5h-1.3v-2.8h1.3c1.3,0,2.3-0.2,2.9-0.5 s0.9-0.9,0.9-1.8c0-1.3-0.8-1.9-2.4-1.9c-0.6,0-1.1,0.1-1.7,0.3s-1.2,0.5-1.9,1l-1.7-2.5c1.6-1.1,3.4-1.7,5.6-1.7 c1.8,0,3.2,0.4,4.2,1.1S159.6,147.3,159.6,148.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "of"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.7,153.6c0,1-0.3,1.9-0.8,2.5s-1.3,0.9-2.2,0.9c-0.6,0-1.1-0.1-1.5-0.4s-0.8-0.7-1-1.2s-0.4-1.1-0.4-1.8 c0-1,0.3-1.9,0.8-2.4s1.2-0.9,2.2-0.9c0.9,0,1.6,0.3,2.1,0.9S139.7,152.6,139.7,153.6z M134.8,153.6c0,0.8,0.2,1.4,0.5,1.9 s0.8,0.6,1.4,0.6s1.1-0.2,1.5-0.6s0.5-1.1,0.5-1.9c0-0.8-0.2-1.4-0.5-1.9s-0.8-0.6-1.5-0.6c-0.6,0-1.1,0.2-1.4,0.6 S134.8,152.8,134.8,153.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.3,151.2h-1.6v5.7h-1v-5.7h-1.1v-0.4l1.1-0.4V150c0-1.6,0.7-2.4,2.1-2.4c0.3,0,0.7,0.1,1.2,0.2l-0.3,0.8 c-0.4-0.1-0.7-0.2-1-0.2c-0.4,0-0.6,0.1-0.8,0.4s-0.3,0.6-0.3,1.2v0.4h1.6V151.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Of3);
export default __webpack_public_path__ + "static/media/step_1_of_3.4f469155fcaeb440eb2dba226cb9280f.svg";
export { ForwardRef as ReactComponent };